import { BsArrowRight } from "react-icons/bs";

export default function HomeHowItWorks() {
  const steps = [
    { title: "Enter Details", text: "Select pickup and delivery locations, choose package size" },
    { title: "Book & Pay", text: "Get instant quote, confirm booking and make secure payment" },
    { title: "Track & Receive", text: "Track in real-time and receive your parcel safely" },
  ];

  return (
    <section className="max-w-6xl mx-auto w-full px-4 sm:px-5 py-16 md:py-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl text-purple-800 mb-3">How It Works</h2>
        <p className="text-gray-600 text-lg">Simple, fast, and reliable</p>
      </div>
      <ol className="relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        <span className="hidden md:block absolute top-8 left-[16.66%] right-[16.66%] h-0.5 bg-gradient-to-r from-purple-200 via-purple-400 to-purple-200" aria-hidden="true" />
        {steps.map((step, index) => (
          <li key={step.title} className="relative flex flex-col items-center text-center">
            <span className="relative z-10 flex h-16 w-16 items-center justify-center rounded-full bg-purple-600 text-2xl font-semibold text-white shadow-lg shadow-purple-600/30 ring-8 ring-white mb-5">
              {index + 1}
            </span>
            <div className="w-full flex-1 bg-white rounded-2xl border border-purple-100 shadow-sm p-6">
              <h3 className="text-xl text-gray-900 mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.text}</p>
            </div>
          </li>
        ))}
      </ol>
      <div className="text-center mt-8">
        <a href="/how-it-works" className="inline-flex items-center gap-2 text-sm font-medium text-purple-700 hover:text-purple-900">
          See the full process <BsArrowRight aria-hidden="true" />
        </a>
      </div>
    </section>
  );
}
